module.exports = __webpack_public_path__ + "static/valera-a82c7fc409ca53b9d6ed130d1c661c99.mp4";